import React, { useState, useEffect } from "react";
// import { Card } from "react-bootstrap";
import axios from "axios";
import {
  Card,
  CardContent,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Grid,
  Typography,
} from "@mui/material";
function Admincreateclass() {
  const [data, setdata] = useState([]);
  const [data1, setdata1] = useState([]);
  const [standard, setstandard] = useState(" ");
  const [subject, setsubject] = useState(" ");
  const [time, settime] = useState(" ");
  const [time2, settime2] = useState(" ");
  const [teacheremail, setteacheremail] = useState(" ");
  const [studentemail, setstudentemail] = useState(" ");
  const [others, setothers] = useState(" ");
  const [date, setdate] = useState(" ");
  const [date2, setdate2] = useState(" ");

  const formdata = new FormData();

  const postimage = async () => {
    try {
      const config = {
        url: "/admin/addcreateclass",
        method: "post",
        baseURL: "/api",
        headers: { "content-type": "application/json" },
        data: {
          teacherid: teacheremail,
          studentid: studentemail,
          time: time,
          time2: time2,
          date: date,
          date2: date2,
          other: others,
          subject: subject,
          standard: standard,
        },
        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        console.log(res.data);
        alert("Create Class add successfully");
        window.location.assign("/admin/classlist");
      }
    } catch (error) {
      console.log(error);
    }
  };
  console.log(studentemail, teacheremail);

  useEffect(() => {
    getusers();
  }, []);

  const getusers = () => {
    try {
      axios
        .get(`/api/user/getallUser1`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setdata1(response.data.success);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };

  useEffect(() => {
    getteacherusers();
  }, []);

  const getteacherusers = () => {
    try {
      axios
        .get(`/api/user/getAllUser`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setdata(response.data.success);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
    <Card sx={{ maxWidth: 600, boxShadow: 3, p: 3 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Add Create Class
      </Typography>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField fullWidth label="Start Date" type="date" InputLabelProps={{ shrink: true }} onChange={(e) => setdate(e.target.value)} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="Start Time" type="time" InputLabelProps={{ shrink: true }} onChange={(e) => settime(e.target.value)} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="End Date" type="date" InputLabelProps={{ shrink: true }} onChange={(e) => setdate2(e.target.value)} />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="End Time" type="time" InputLabelProps={{ shrink: true }} onChange={(e) => settime2(e.target.value)} />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Teacher</InputLabel>
              <Select value={teacheremail} onChange={(e) => setteacheremail(e.target.value)}>
                <MenuItem value="">Select Teacher</MenuItem>
                {data?.map((email) => (
                  <MenuItem key={email._id} value={email._id}>{email.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Student</InputLabel>
              <Select value={studentemail} onChange={(e) => setstudentemail(e.target.value)}>
                <MenuItem value="">Select Student</MenuItem>
                {data1?.map((email) => (
                  <MenuItem key={email._id} value={email._id}>{email.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField fullWidth label="Subject" onChange={(e) => setsubject(e.target.value)} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth label="Title" onChange={(e) => setothers(e.target.value)} />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Class Name</InputLabel>
              <Select value={standard} onChange={(e) => setstandard(e.target.value)}>
                <MenuItem value="">Select Class</MenuItem>
                {Array.from({ length: 12 }, (_, i) => (
                  <MenuItem key={i + 1} value={`Class ${i + 1}`}>Class {i + 1}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} textAlign="center">
            <Button variant="contained" color="primary" sx={{ mt: 2, borderRadius: 2, px: 4 }} onClick={postimage}>
              Create Class
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </div>
  );
}

export default Admincreateclass;
